import Search from '../../../../general-ui/search-bar/search';
import SelectInput from '../../../../general-ui/select/select';
import Icon, { ICONS } from '../../../../general-ui/icon';



interface ListHeaderProps {
	activeTab: string;
	activeTabCount: number;
	handleSearch: any;
	handleClear: any;
	sortOptions: any;
	sortBy: string;
	setSortBy: any;
}

export default function ListHeader(props: ListHeaderProps): JSX.Element {
	const { activeTab, activeTabCount, handleSearch, handleClear, sortOptions, sortBy, setSortBy } = props;
	return (
		<div className="events-list-header">
			<h4>{activeTab} <span className="count">{activeTabCount}</span></h4>
			<div className="search-sort-container">
				<Search
					onSearch={handleSearch}
					onClear={handleClear}
				/>
				<SelectInput
					placeholder="Sort by"
					mainIcon={
						<Icon
							name={ICONS.KEYBOARD_ARROW_DOWN}
							size={14}
							color="white"
						/>
					}
					options={sortOptions}
					selected={sortBy}
					small
					noMaxHeight
					onChange={setSortBy}
				/>
			</div>
		</div>
	);
}